<script setup lang="ts">
const store = useStore()
const { shopInformation } = storeToRefs(store)
const phone = `tel:+48${shopInformation.value.shopInformation.phone.replaceAll(' ', '')}`
const mail = `mailto:${shopInformation.value.shopInformation.contactEmail}`
useHead({
  titleTemplate: 'System rezerwacyjny - %s',
  meta: [
    { name: 'robots', content: 'index,follow' }
  ]
})
</script>

<template>
  <div class="container mx-auto">
    <Breadcrumbs :breadcrumbs="[{ name: 'System rezerwacyjny' }]" />
    <div class="flex xs:flex-col justify-between gap-[50px]">
      <div class="sm:w-1/3 flex flex-col">
        <span class="text-20 font-medium mb-[20px]">Jeśli numer vouchera zaczyna się od <span class="font-bold">GO2022..., GO2023...</span> sprawdź go tu:</span>
        <NuxtLink to="https://old.go-racing.pl/system-rezerwacyjny" class="btn btn-secondary btn-lg" target="_blank">
          <span>Sprawdź</span>
          <i class="icon-arrow-button text-10" />
        </NuxtLink>
      </div>
      <div class="sm:w-1/3 flex flex-col">
        <span class="text-20 font-medium mb-[20px]">Jeśli numer vouchera zaczyna się od <span class="font-bold">VCOV...</span> sprawdź go tu:</span>
        <NuxtLink to="https://wykonawca.emotivo.pl" class="btn btn-secondary btn-lg" target="_blank">
          <span>Sprawdź</span>
          <i class="icon-arrow-button text-10" />
        </NuxtLink>
      </div>
    </div>
    <div class="flex flex-col items-center text-20 font-medium mt-[50px]">
      <span>Masz pytania, skontaktuj się z nami:</span>
      <NuxtLink :to="mail" class="inline-flex">
        {{ shopInformation.shopInformation.contactEmail }}
      </NuxtLink>
      <NuxtLink :to="phone" class="inline-flex">
        {{ shopInformation.shopInformation.phone }}
      </NuxtLink>
    </div>
  </div>
</template>
